import { useTranslation } from "react-i18next";

const VirtualCartBox = ({finalCartItems, uniqueKey}) => {
    const { t } = useTranslation();
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <div>
            <div className="hidden sm:flex divide-x-2 divide-gray-dark1 divide-dashed sm:h-20 justify-end text-[9px] sm:text-[15px]"> 
                {uniqueKey ?
                    <div className="pr-1 lg:pr-2 space-y-2 md:space-y-3">
                        <h1 className="capitalize font-semibold text-light-400">{ t('cart number')}</h1>
                        <div className="font-bold">{uniqueKey}</div>
                    </div>
                    :
                    <div></div>
                }
                <div className="px-1 lg:px-2 space-y-2 md:space-y-3">
                    <h1 className="capitalize font-semibold text-light-400">{ t('no. of items')}</h1>
                    <div className="font-bold">{finalCartItems.itemsCount}</div>
                </div>
                <div className="px-1 lg:px-2 space-y-2 md:space-y-3">
                    <h1 className="capitalize font-semibold text-light-400">{ t('total quantity')}</h1>
                    <div className="font-bold">{finalCartItems.totalQuantity ? formatter.format(finalCartItems.totalQuantity) : formatter.format(0)}</div>
                </div>
                <div className="px-1 lg:px-2 space-y-2 md:space-y-3">
                    <h1 className="capitalize font-semibold text-light-400">{ t('net amount')}</h1>
                    <div className="font-bold">{finalCartItems.netAmount ? formatter.format(finalCartItems.netAmount) : formatter.format(0)} €</div>
                </div>
                <div className="px-1 lg:px-2 space-y-2 md:space-y-3">
                    <h1 className="capitalize font-semibold text-light-400">{ t('total')} <span className="uppercase">{t('vat')}</span></h1>
                    <div className="font-bold">{finalCartItems.vats ? formatter.format(finalCartItems.vats) : formatter.format(0)} €</div>
                </div>
                <div className="px-1 lg:px-2 space-y-2 md:space-y-3">
                    <h1 className="capitalize font-semibold text-light-400">{ t('total amount')}</h1>
                    <div className="font-bold">{finalCartItems.finalAmount ? formatter.format(finalCartItems.finalAmount) : formatter.format(0)} €</div>
                </div>
            </div> 
            <div className="grid grid-cols-2 sm:hidden text-[11px] gap-4 text-light-400">
                {/* Left column */}
                <div className="space-y-2">
                    <div className="flex items-center gap-1">
                        <h1 className="capitalize">{t('cart number')}:</h1>
                        <div className="font-bold text-dark-100">{uniqueKey}</div>
                    </div>
                    <div className="flex items-center gap-1">
                        <h1 className="capitalize">{t('no. of items')}:</h1>
                        <div className="font-bold text-dark-100">{finalCartItems.itemsCount}</div>
                    </div>
                    <div className="flex items-center gap-1">
                        <h1 className="capitalize">{t('total quantity')}:</h1>
                        <div className="font-bold text-dark-100">
                            {finalCartItems.totalQuantity ? formatter.format(finalCartItems.totalQuantity) : formatter.format(0)}
                        </div>
                    </div>
                    <div className="flex items-center gap-1">
                        <h1 className="capitalize">{t('disc. value')} in €:</h1>
                        <div className="font-bold text-dark-100">{finalCartItems.discountAmount ? formatter.format(finalCartItems.discountAmount) : formatter.format(0)}</div>
                    </div>
                </div>
                {/* Right column */}
                <div className="space-y-2">
                    <div className="flex items-center justify-end gap-1">
                        <h1 className="capitalize">{t('net amount')}:</h1>
                        <div className="font-bold text-dark-100">{finalCartItems.netAmount ? formatter.format(finalCartItems.netAmount) : formatter.format(0)} €</div>
                    </div>
                    <div className="flex items-center justify-end gap-1">
                        <h1 className="capitalize">{t('extra taxes')}:</h1>
                        <div className="font-bold text-dark-100">
                            {finalCartItems.totalTaxes ? formatter.format(finalCartItems.totalTaxes) : formatter.format(0)} €
                        </div>
                    </div>
                    <div className="flex items-center justify-end gap-1">
                        <h1 className="capitalize">{ t('total')} <span className="uppercase">{t('vat')}:</span></h1>
                        <div className="font-bold text-dark-100">{finalCartItems.vats ? formatter.format(finalCartItems.vats) : formatter.format(0)} €</div>
                    </div>
                    <div className="flex items-center justify-end gap-1">
                        <h1 className="capitalize">{t('total amount')}:</h1>
                        <div className="font-bold text-dark-100">{finalCartItems.finalAmount ? formatter.format(finalCartItems.finalAmount) : formatter.format(0)} €</div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default VirtualCartBox;